import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from "axios";
import img1 from "../../assets/images/noimage.jpg";
import { MyApi } from "../../MyApi";

export default function HomeBlog({ limit = 6 }) {
  const [Blog, setBlog] = useState([]);
  const [loading, setLoading] = useState(true);

  // ✅ Format date helper
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        // Optional: send limit to API if supported
        const res = await axios.get(MyApi.BASE_URL + MyApi.BLOGALLLIST, {
          headers: { Authorization: MyApi.SECRET_KEY },
          params: { limit }, // ✅ pass limit to API
        });

        if (res.data?.status) {
          setBlog(res.data.data || []);
        }
      } catch (error) {
        console.error("Expert Blog API error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBlog();
  }, [limit]);

  if (loading) {
    return <p className="text-center py-5">Loading Blog...</p>;
  }

  return (
    <div className="bg_image experts">
      <Container>
        <div className="servi_bx">
          <div className="heading_a">
            <span>Articles</span>
            <h1>Latest News & Blogs</h1>
          </div>

          <Row className="g-3">
            {Blog.length > 0 ? (
              Blog.slice(0, limit).map((item, index) => {
                if (!item?.product || !item?.parent_category) return null;

                const product = item.product;
                const category = item.parent_category;

                return (
                  <Col md={4} xs={12} key={product.id || index}>
                    <div className="blog-card">
                      <Link to={`/${category.categoryurl}/${product.producturl}`}>
                        <div className="blog-img">
                          <img
                            src={product.image_url || img1}
                            alt={product.productname}
                            loading="lazy"
                            onError={(e) => (e.target.src = img1)}
                          />
                        </div>
                      </Link>

                      <div className="blog-content">
                        {product.created_on && (
                          <span className="blog-date">{formatDate(product.created_on)}</span>
                        )}

                        <h3>{product.productname}</h3>

                        {product.productshortcontent && <p>{product.productshortcontent}</p>}

                        <Link
                          to={`/${category.categoryurl}/${product.producturl}`}
                          className="read-more"
                        >
                          Read More →
                        </Link>
                      </div>
                    </div>
                  </Col>
                );
              })
            ) : (
              <Col>
                <p className="text-center">No Blog found</p>
              </Col>
            )}
          </Row>

          <div className="text-center mt-5">
            <Link to="/blog" className="button_style">
              <span>View All</span>
            </Link>
          </div>
        </div>
      </Container>
    </div>
  );
}
